import { useEffect } from "react";

import {
  getCutoverDateForSchema,
  getOlderDataModule,
} from "@/components/StructuredSearch/config/older-data-registry";
import { hasCutoverDateControl } from "@/components/StructuredSearch/config/schema-utils";
import { useStructuredSearchStore } from "@/components/StructuredSearch";
import { useUser } from "@/context/user-context";

export const useApplyOlderDataConstraints = (enabled = true) => {
  const store = useStructuredSearchStore();
  const { activeWorkspace } = useUser();
  const { schema } = store;
  const olderData = getOlderDataModule(schema);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!hasCutoverDateControl(schema)) {
      return;
    }

    const cutoverDate = getCutoverDateForSchema(schema, activeWorkspace);

    // Keep the FE state aligned with the backend when search routes through the
    // Postgres fallback path.
    if (
      !olderData.isPostgresOnlySearch({
        dateRange: store.dateRange,
        cutoverDate,
      })
    ) {
      return;
    }

    const sanitizedFilters = olderData.sanitizeFiltersForOlderData(store.filters);
    if (sanitizedFilters !== store.filters) {
      store.setFiltersFromURL(sanitizedFilters);
    }

    if (store.q.trim()) {
      store.setSearch("");
    }

    const hasIncompatibleInProgressFilter =
      (Boolean(store.inProgress.field) &&
        !olderData.isOlderDataFieldSupported(store.inProgress.field)) ||
      (Boolean(store.inProgress.field) &&
        Boolean(store.inProgress.operator) &&
        !olderData.isOlderDataOperatorSupported(store.inProgress.field, store.inProgress.operator));

    if (hasIncompatibleInProgressFilter) {
      if (store.editingFilterId) {
        store.removeFilter(store.editingFilterId);
      }
      store.openFieldSuggest();
    }
  }, [
    activeWorkspace,
    enabled,
    olderData,
    schema,
    store,
    store.dateRange,
    store.editingFilterId,
    store.filters,
    store.inProgress.field,
    store.inProgress.operator,
    store.q,
  ]);
};
